import { render, staticRenderFns } from "./EcommerceCard.vue?vue&type=template&id=63e51573&scoped=true"
import script from "./EcommerceCard.vue?vue&type=script&lang=js"
export * from "./EcommerceCard.vue?vue&type=script&lang=js"
import style0 from "./EcommerceCard.vue?vue&type=style&index=0&id=63e51573&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e51573",
  null
  
)

export default component.exports